import './polyfills.js';
import 'core-js/modules/es.regexp.exec';
import 'core-js/modules/es.string.split';
import 'core-js/modules/es.array.every';
import 'core-js/modules/es.array.filter';
import 'core-js/modules/es.array.iterator';
import 'core-js/modules/es.array.join';
import 'core-js/modules/es.function.name';
import 'core-js/modules/es.object.to-string';
import 'core-js/modules/es.regexp.constructor';
import 'core-js/modules/es.regexp.to-string';
import 'core-js/modules/es.string.iterator';
import 'core-js/modules/es.string.search';
import 'core-js/modules/es.string.sub';
import 'core-js/modules/web.dom-collections.iterator';
import 'core-js/modules/web.url';
import 'regenerator-runtime/runtime';
import 'core-js/modules/es.symbol';
import 'core-js/modules/es.symbol.description';
import 'core-js/modules/es.symbol.async-iterator';
import 'core-js/modules/es.symbol.iterator';
import 'core-js/modules/es.promise';
import 'url-search-params-polyfill';
import Cookies from 'js-cookie';
import sha256 from 'crypto-js/sha256';
import axios from 'axios';
import qs from 'qs';
import 'core-js/modules/es.string.replace';
import 'core-js/modules/es.typed-array.uint8-array';
import 'core-js/modules/es.typed-array.copy-within';
import 'core-js/modules/es.typed-array.every';
import 'core-js/modules/es.typed-array.fill';
import 'core-js/modules/es.typed-array.filter';
import 'core-js/modules/es.typed-array.find';
import 'core-js/modules/es.typed-array.find-index';
import 'core-js/modules/es.typed-array.for-each';
import 'core-js/modules/es.typed-array.includes';
import 'core-js/modules/es.typed-array.index-of';
import 'core-js/modules/es.typed-array.iterator';
import 'core-js/modules/es.typed-array.join';
import 'core-js/modules/es.typed-array.last-index-of';
import 'core-js/modules/es.typed-array.map';
import 'core-js/modules/es.typed-array.reduce';
import 'core-js/modules/es.typed-array.reduce-right';
import 'core-js/modules/es.typed-array.reverse';
import 'core-js/modules/es.typed-array.set';
import 'core-js/modules/es.typed-array.slice';
import 'core-js/modules/es.typed-array.some';
import 'core-js/modules/es.typed-array.sort';
import 'core-js/modules/es.typed-array.subarray';
import 'core-js/modules/es.typed-array.to-locale-string';
import 'core-js/modules/es.typed-array.to-string';
import Base64 from 'crypto-js/enc-base64';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function __async(g) {
  return new Promise(function (s, j) {
    function c(a, x) {
      try {
        var r = g[x ? "throw" : "next"](a);
      } catch (e) {
        j(e);
        return;
      }

      r.done ? s(r.value) : Promise.resolve(r.value).then(c, d);
    }

    function d(e) {
      c(e, 1);
    }

    c();
  });
}

function decodeToken(token) {
  var jwt = token.split('.');
  var decodedToken;

  try {
    decodedToken = {
      header: JSON.parse(base64UrlDecode(jwt[0])),
      payload: JSON.parse(base64UrlDecode(jwt[1])),
      signature: jwt[2]
    };
  } catch (e) {
    throw new Error('Malformed token');
  }

  return decodedToken;
}

function base64UrlToBase64(b64u) {
  return b64u.replace(/-/g, '+').replace(/_/g, '/');
}

function base64UrlEncode(string) {
  return string.toString(Base64).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}

function base64UrlDecode(b64u) {
  var b64 = base64UrlToBase64(b64u);

  switch (b64.length % 4) {
    case 0:
      break;

    case 2:
      b64 += '==';
      break;

    case 3:
      b64 += '=';
      break;

    default:
      throw 'Invalid b64 URL string';
  }

  var decoded = atob(b64);

  try {
    return decodeURIComponent(escape(decoded));
  } catch (e) {
    return decoded;
  }
}

function stringToBuffer(str) {
  var buffer = new Uint8Array(str.length);

  for (var i = 0; i < str.length; i++) {
    buffer[i] = str.charCodeAt(i);
  }

  return buffer;
}

function genRandomString(length) {
  var randomCharset = 'abcdefghijklnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  var random = '';

  for (var c = 0, cl = randomCharset.length; c < length; ++c) {
    random += randomCharset[Math.floor(Math.random() * cl)];
  }

  return random;
}

var ACCESS_TOKEN = 'access_token';
var ID_TOKEN = 'id_token';
var REFRESH_TOKEN = 'refresh_token';
var PKCE_KEY = 'pkce-storage';
var OKTA_OAUTH_STATE = 'okta-oauth-state';
var OKTA_OAUTH_NONCE = 'okta-oauth-nonce';
var DEFAULT_CODE_CHALLENGE_METHOD = 'S256';
var REFERRER_URI_KEY = 'referrerUri';
var DEFAULT_GRANT_TYPE = 'authorization_code';
var REFRESH_GRANT_TYPE = 'refresh_token';
var codeVerifier;
var state;
var nonce;
var codeChallenge; // In-memory storage of tokens.
// TODO: Add more storage options (?)

var store = {};
store[ACCESS_TOKEN] = null;
store[ID_TOKEN] = null;
var headers = {
  'content-type': 'application/x-www-form-urlencoded'
};
/**
 * Revokes access token using the revoke endpoint, clears all local tokens, then ends SSO session by redirecting to logout endpoint. Throws error upon failure and redirects upon success.
 *
 * @param {*} sdk: sdk object with configuration
 * @param {string} [uri=null] URI to redirect to, defaults to sdk.logoutUri
 */

function logout(sdk) {
  var uri = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return __async( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var accessToken, refreshToken, idToken, attrs, searchParams, newPathQuery;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            accessToken = getAccessToken();
            refreshToken = getRefreshToken();
            idToken = getIdToken();

            if (!(!accessToken || !idToken)) {
              _context.next = 5;
              break;
            }

            throw new Error('You have a missing ID or Access Token. Please login again to retrieve them.');

          case 5:
            attrs = qs.stringify({
              client_id: sdk.clientId,
              token: sdk.refresh ? refreshToken : accessToken,
              token_type_hint: sdk.refresh ? REFRESH_TOKEN : ACCESS_TOKEN
            }); // Revoke access token. Session will still be active at this point, but can't use access token to retrieve resources

            _context.prev = 6;
            _context.next = 9;
            return axios.post(sdk.REVOKE_ENDPOINT, attrs, {
              headers: headers
            });

          case 9:
            _context.next = 15;
            break;

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](6);
            console.log('Unable to log out ' + _context.t0);
            throw new Error(_context.t0);

          case 15:
            clearOAuthValues(); // End session

            _context.prev = 16;

            if ('URLSearchParams' in window) {
              searchParams = new URLSearchParams(window.location.search);
              searchParams.set('id_token_hint', idToken);
              searchParams.set('post_logout_redirect_uri', uri || sdk.logoutUri);
              newPathQuery = '/?' + searchParams.toString();
            }

            window.location.href = sdk.LOGOUT_ENDPOINT + newPathQuery;
            _context.next = 25;
            break;

          case 21:
            _context.prev = 21;
            _context.t1 = _context["catch"](16);
            console.log('Unable to log out ' + _context.t1);
            throw new Error(_context.t1);

          case 25:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[6, 11], [16, 21]]);
  })());
}
/**
 * Returns true if a user is authenticated, false if not
 *
 * @returns {boolean}
 */


function isAuthenticated() {
  var accessToken = getAccessToken();
  var idToken = getIdToken();

  if (accessToken != null && idToken != null) {
    return !isExpired(accessToken) && !isExpired(idToken);
  }

  return false;
}
/**
 * Logs in the user. If there exists a session, requests an auth code. If a session does not exist, redirects to the custom login.
 * @param {*} sdk object with configuration
 * @param {string} uri: optional uri to return back to if not default
 * @param {any} customState: optional custom state
 * @param {any} externalIdp: optional external idp to log into
 */


function login(sdk) {
  var uri = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var customState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var externalIdp = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  return __async( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var session;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            setReferrerUri(uri);
            _context2.next = 3;
            return getSession(sdk);

          case 3:
            session = _context2.sent;
            session != null || externalIdp ? requestAuthCode(sdk, customState, externalIdp) : redirectToCustomLogin(sdk, customState);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })());
}
/**
 * Retrieves tokens from the token endpoint, verifies the ID token, and upon successful verification, stores both tokens in memory.
 *
 * @param {*} sdk object with configuration
 */


function retrieveAndStoreTokens(sdk) {
  return __async( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
    var isCwpWorkflow, tokenAttrs, res, idToken, tokenVerified;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            isCwpWorkflow = ['state', 'nonce', 'code', 'code_verifier'].every(function (param) {
              return !!getQueryParam(param);
            }); // Verify incoming state

            if (!(!isCwpWorkflow && !verifyState())) {
              _context3.next = 3;
              break;
            }

            throw new Error('State verification failed -- state in URL mismatched with stored state.');

          case 3:
            // Using qs.stringify because of content-type
            tokenAttrs = qs.stringify({
              client_id: sdk.clientId,
              redirect_uri: sdk.redirectUri,
              grant_type: DEFAULT_GRANT_TYPE,
              code: getAuthCode(),
              code_verifier: getCodeVerifier(isCwpWorkflow),
              scope: sdk.scopes.join(' ')
            });
            _context3.prev = 4;
            _context3.next = 7;
            return axios.post(sdk.TOKEN_ENDPOINT, tokenAttrs, {
              headers: headers
            });

          case 7:
            res = _context3.sent;
            idToken = res.data.id_token;
            _context3.next = 11;
            return verifyIdToken(sdk, idToken, isCwpWorkflow);

          case 11:
            tokenVerified = _context3.sent;

            if (!tokenVerified) {
              _context3.next = 18;
              break;
            }

            setItem(ACCESS_TOKEN, res.data.access_token);
            setItem(ID_TOKEN, idToken);
            if (sdk.refresh) setItem(REFRESH_TOKEN, res.data.refresh_token);
            _context3.next = 19;
            break;

          case 18:
            throw new Error('ID Token Verification failed.');

          case 19:
            _context3.next = 25;
            break;

          case 21:
            _context3.prev = 21;
            _context3.t0 = _context3["catch"](4);
            console.log(_context3.t0);
            throw new Error('Error occurred while fetching the tokens.');

          case 25:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[4, 21]]);
  })());
}
/**
 * Retrieves new tokens from the token endpoint given a refresh token, verifies the ID token, and upon successful verification, stores both tokens in memory.
 *
 * @param {*} sdk object with configuration
 */


function retrieveAndStoreNewTokens(sdk) {
  return __async( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
    var tokenAttrs, res, idToken, tokenVerified;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            // Using qs.stringify because of content-type
            tokenAttrs = qs.stringify({
              client_id: sdk.clientId,
              redirect_uri: sdk.redirectUri,
              grant_type: REFRESH_GRANT_TYPE,
              scope: sdk.scopes.join(' '),
              refresh_token: getRefreshToken()
            });
            _context4.prev = 1;
            _context4.next = 4;
            return axios.post(sdk.TOKEN_ENDPOINT, tokenAttrs, {
              headers: headers
            });

          case 4:
            res = _context4.sent;
            idToken = res.data.id_token;
            _context4.next = 8;
            return verifyIdToken(sdk, idToken, false, true);

          case 8:
            tokenVerified = _context4.sent;

            if (!tokenVerified) {
              _context4.next = 15;
              break;
            }

            setItem(ACCESS_TOKEN, res.data.access_token);
            setItem(ID_TOKEN, idToken);
            setItem(REFRESH_TOKEN, res.data.refresh_token);
            _context4.next = 16;
            break;

          case 15:
            throw new Error('ID Token Verification failed.');

          case 16:
            _context4.next = 22;
            break;

          case 18:
            _context4.prev = 18;
            _context4.t0 = _context4["catch"](1);
            console.log(_context4.t0);
            throw new Error('Error occurred while fetching the tokens.');

          case 22:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[1, 18]]);
  })());
}
/**
 * Generates a code verifier + challenge, state, and nonce. Stores the code verifier and the redirect URI in local storage. Stores the state and nonce as cookies.
 * Redirects to the custom login with the following items in the URI: issuer_uri, client_id, redirect_uri, code_challenge, code_challenge_method, nonce, scope, state.
 *
 * @param {*} sdk object with configuration
 * @param {string} [customState=null] optionally pass in a state. Otherwise, it will be automatically generated.
 */


function redirectToCustomLogin(sdk) {
  var customState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  generateAndStoreOAuthValues(sdk, customState); // Generating all items needed for initial redirect to custom login

  if ('URLSearchParams' in window) {
    var searchParams = new URLSearchParams(window.location.search);
    searchParams.set('issuer_uri', sdk.issuer);
    searchParams.set('client_id', sdk.clientId);
    searchParams.set('redirect_uri', sdk.redirectUri);
    searchParams.set('code_challenge', codeChallenge);
    searchParams.set('code_challenge_method', DEFAULT_CODE_CHALLENGE_METHOD);
    searchParams.set('nonce', nonce);
    searchParams.set('scope', sdk.scopes.join(' '));
    searchParams.set('state', state);
    searchParams.set('disable_forgot_password', sdk.disableForgotPwd);
    searchParams.set('aladdin_auth', sdk.aladdinAuth);
    searchParams.set('disable_registration', sdk.disableRegistration);

    if (sdk.locale !== undefined && sdk.locale !== null) {
      searchParams.set('locale', sdk.locale);
    }

    if (sdk.invTypeHint !== undefined && sdk.invTypeHint !== null) {
      searchParams.set('inv_type_hint', sdk.invTypeHint);
    }

    if (sdk.postCredentialOperationRedirectUri !== undefined && sdk.postCredentialOperationRedirectUri !== null) {
      console.log('postCredential: ' + sdk.postCredentialOperationRedirectUri);
      searchParams.set('post_credential_operation_redirect_uri', sdk.postCredentialOperationRedirectUri);
    }

    if (sdk.site !== undefined && sdk.site !== null) {
      searchParams.set('site', sdk.site);
    }

    if (sdk.brand !== undefined && sdk.brand !== null) {
      searchParams.set('brand', sdk.brand);
    }

    if (sdk.idpName !== undefined && sdk.idpName !== null) {
      searchParams.set('idp_name', sdk.idpName);
    }

    var newPathQuery = '/?' + searchParams.toString();
  }

  window.location.href = sdk.CUSTOM_LOGIN_URI + newPathQuery;
}
/**
 * 
 * Redirects to the change credentials section of the custom login 
 *
 * @param {*} sdk object with configuration
 */


function redirectToChangeCredentials(sdk) {
  window.location.href = sdk.CHANGE_CREDENTIALS_URI + buildChangePathQuery(sdk);
}
/**
 * 
 * Redirects to the change username section of the custom login 
 *
 * @param {*} sdk object with configuration
 */


function redirectToChangeUsername(sdk) {
  window.location.href = sdk.CHANGE_USER_NAME_URI + buildChangePathQuery(sdk);
}
/**
 * 
 * Redirects to the change recovery question section of the custom login 
 *
 * @param {*} sdk object with configuration
 */


function redirectToChangeRecoveryQuestion(sdk) {
  window.location.href = sdk.CHANGE_RECOVERY_QUESTION_URI + buildChangePathQuery(sdk);
}
/**
 * 
 * Builds a change path query.
 *
 * @param {*} sdk object with configuration
 */


function buildChangePathQuery(sdk) {
  // Generating all items needed for redirect to custom login
  if ('URLSearchParams' in window) {
    var userName = getUserName();

    if (userName == null) {
      throw new Error('Authenticate before attempting a change operation.');
    }

    var searchParams = new URLSearchParams(window.location.search);
    searchParams.set('issuerUri', sdk.issuer);
    searchParams.set('clientId', sdk.clientId);
    searchParams.set('redirectUri', sdk.logoutUri);

    if (sdk.site !== undefined && sdk.site !== null) {
      searchParams.set('site', sdk.site);
    }

    console.log("Locale " + sdk.locale);

    if (sdk.locale !== undefined && sdk.locale !== null) {
      searchParams.set('locale', sdk.locale);
    }

    if (sdk.brand !== undefined && sdk.brand !== null) {
      searchParams.set('brand', sdk.brand);
    }

    return '/?' + searchParams.toString();
  }
}
/**
 * If session exists, returns session object. Else, logs error and returns null.
 *
 * @param {*} sdk object with configuration
 * @returns session object if it exists, or null
 */


function getSession(sdk) {
  return __async( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
    var response;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return axios.get(sdk.SESSIONS_ENDPOINT, {
              withCredentials: true
            });

          case 3:
            response = _context5.sent;
            return _context5.abrupt("return", response.data);

          case 7:
            _context5.prev = 7;
            _context5.t0 = _context5["catch"](0);
            if (_context5.t0.response && _context5.t0.response.status === 404) console.log('Session not found.');
            return _context5.abrupt("return", null);

          case 11:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 7]]);
  })());
}
/**
 * Generates a new code verifier, state and nonce then redirects to authorization code endpoint with client_id,
 * redirect_uri, code_challenge, code_challenge_method, nonce, scope, state, and response_type = code
 *
 * @param {*} sdk object with configuration
 * @param {*} customState optional custom state
 * @param {*} externalIdp optional external idp to log into
 */


function requestAuthCode(sdk) {
  var customState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var externalIdp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  generateAndStoreOAuthValues(sdk, customState);

  if ('URLSearchParams' in window) {
    var searchParams = new URLSearchParams(window.location.search);
    searchParams.set('client_id', sdk.clientId);
    searchParams.set('redirect_uri', sdk.redirectUri);
    searchParams.set('code_challenge', codeChallenge);
    searchParams.set('code_challenge_method', DEFAULT_CODE_CHALLENGE_METHOD);
    searchParams.set('nonce', nonce);
    searchParams.set('scope', sdk.scopes.join(' '));
    searchParams.set('state', customState ? customState : state);
    searchParams.set('response_type', 'code');
    externalIdp && searchParams.set('idp', externalIdp);
    var newPathQuery = '/?' + searchParams.toString();
  }

  window.location.href = sdk.AUTHORIZE_ENDPOINT + newPathQuery;
}
/**
 * Retrieve the stored access token if it exists, null if not.
 *
 * @returns {string} access token
 */


function getAccessToken() {
  var accessToken = getItem(ACCESS_TOKEN);
  if (accessToken === null) console.log('There is no access token stored. Please login.');
  return accessToken;
}
/**
 * Retrieve the ID token if it exists, null if not.
 *
 * @returns {string} ID token
 */


function getIdToken() {
  var idToken = getItem(ID_TOKEN);
  if (idToken === null) console.log('There is no ID token. Please login.');
  return idToken;
}
/**
 * Retrieve the ID token if it exists, null if not.
 *
 * @returns {string} ID token
 */


function getRefreshToken() {
  var refreshToken = getItem(REFRESH_TOKEN);
  if (refreshToken === null) console.log('There is no refresh token. Please login.');
  return refreshToken;
}
/**
 * Returns the username of the currently authenticated user, null if not authenticated.
 *
 * @returns {string} Username
 */


function getUserName() {
  var idToken = getIdToken();
  return idToken !== null ? decodeToken(idToken).payload.name : null;
}
/**
 * Returns the user ID of the currently authenticated user, null if not authenticated.
 *
 * @returns {string} User ID
 */


function getUserId() {
  var idToken = getIdToken();
  return idToken !== null ? decodeToken(idToken).payload.sub : null;
}
/**
 * Returns the expiry of the current access token, null if not authenticated.
 *
 * @returns {number} expiry
 */


function getExpiry() {
  var accessToken = getAccessToken();
  return accessToken !== null ? decodeToken(accessToken).payload.exp : null;
}
/**
 * Checks state in storage and compares it to state sent by authorization server.
 *
 * @returns boolean indicating whether state matches
 */


function verifyState() {
  return getAuthState() === getState();
}
/**
 * Given an idToken, retrieves the kid of the token and retrieves the N and E values of the public key associated with the kid.
 * It then uses those values to verify the given idToken.
 *
 * @param {*} sdk object with configuration
 * @param {string} idToken - ID token to be verified
 * @returns boolean - true upon successful verification, false if not
 *
 * TODO: Cache key rotation: see https://github.com/auth0/node-jwks-rsa
 */


function verifyIdToken(sdk, idToken, cwp) {
  var refresh = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return __async( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
    var res, keys, decodedIdToken, kid, key, format, algo, extractable, usages, tokenVerification, isTokenValid, isSameIssuer, isSameClientId, isNonceValid;
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return axios.get(sdk.KEYS_ENDPOINT);

          case 3:
            res = _context6.sent;
            _context6.next = 10;
            break;

          case 6:
            _context6.prev = 6;
            _context6.t0 = _context6["catch"](0);
            console.log(_context6.t0);
            return _context6.abrupt("return", false);

          case 10:
            keys = res.data.keys; // Find public key associated with kid

            decodedIdToken = decodeToken(idToken);
            kid = decodedIdToken.header.kid;
            key = keys.filter(function (key) {
              return key.kid === kid;
            })[0];
            format = 'jwk';
            algo = {
              name: 'RSASSA-PKCS1-v1_5',
              hash: {
                name: 'SHA-256'
              }
            };
            extractable = true;
            usages = ['verify'];
            _context6.next = 20;
            return crypto.subtle.importKey(format, key, algo, extractable, usages).then(function (cryptoKey) {
              var jwt = idToken.split('.');
              var payload = stringToBuffer(jwt[0] + '.' + jwt[1]);
              var b64Signature = base64UrlDecode(jwt[2]);
              var signature = stringToBuffer(b64Signature);
              return crypto.subtle.verify(algo, cryptoKey, signature, payload);
            });

          case 20:
            tokenVerification = _context6.sent;
            isTokenValid = tokenVerification === true;
            isSameIssuer = decodedIdToken.payload.iss === sdk.issuer;
            isSameClientId = decodedIdToken.payload.aud === sdk.clientId;
            isNonceValid = refresh === true || decodedIdToken.payload.nonce === getNonce(cwp);
            return _context6.abrupt("return", isTokenValid && isSameIssuer && isSameClientId && !isExpired(idToken) && isNonceValid);

          case 26:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 6]]);
  })());
}
/**
 * Given an encoded token, returns the decoded token.
 * @param {string} token 
 */


function decodeToken$1(token) {
  return decodeToken(token);
}
/**
 * Retrieve a defined query param.
 * https://stackoverflow.com/questions/45758837/script5009-urlsearchparams-is-undefined-in-ie-11
 */


function getQueryParam(name) {
  var results = new RegExp('[?&]' + name + '=([^&#]*)').exec(window.location.href);

  if (results == null) {
    return null;
  } else {
    return decodeURIComponent(results[1]) || 0;
  }
}

function clearOAuthValues() {
  // Remove tokens
  store = {};
  clearPkce();
  clearStateAndNonce();
}

function clearPkce() {
  window.localStorage.removeItem(PKCE_KEY);
}

function clearStateAndNonce() {
  Cookies.remove(OKTA_OAUTH_NONCE);
  Cookies.remove(OKTA_OAUTH_STATE);
}

function generateAndStoreOAuthValues(sdk, customState) {
  codeVerifier = genRandomString(64); // If there is no state, generate a state. Otherwise, use the state passed in.

  customState === null || customState === undefined ? state = genRandomString(64) : state = customState;
  nonce = genRandomString(64);
  storePkce(sdk.redirectUri, codeVerifier);
  storeStateAndNonce(state, nonce);
  codeChallenge = generateCodeChallenge(codeVerifier);
}
/**
 * Stores state and nonce in cookies
 */


function storeStateAndNonce(state, nonce) {
  // Setting nonce and state
  Cookies.set(OKTA_OAUTH_NONCE, nonce);
  Cookies.set(OKTA_OAUTH_STATE, state);
}
/**
 * Stores code verifier and redirect URI in local storage
 */


function storePkce(redirectUri, codeVerifier) {
  // Store okta-pkce-storage in local storage
  var oktaPkceStorage = {
    codeVerifier: codeVerifier,
    redirectUri: redirectUri
  };
  window.localStorage.setItem(PKCE_KEY, JSON.stringify(oktaPkceStorage));
}

function getState() {
  return Cookies.get(OKTA_OAUTH_STATE);
}

function getNonce() {
  var cwp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return cwp ? getQueryParam('nonce') : Cookies.get(OKTA_OAUTH_NONCE);
}

function getCodeVerifier() {
  var cwp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return cwp ? getQueryParam('code_verifier') : JSON.parse(window.localStorage.getItem(PKCE_KEY)).codeVerifier;
}

function getAuthState() {
  return getQueryParam('state');
}

function setItem(key, value) {
  store[key] = value;
}

function getItem(key) {
  return store[key];
}

function generateCodeChallenge(codeVerifier) {
  return base64UrlEncode(sha256(codeVerifier));
}

function getAuthCode() {
  return getQueryParam('code');
}
/**
 * Checks if a given token is expired
 * @param {*} decoded - decoded token
 */


function isExpired(encoded) {
  var decoded = decodeToken(encoded);
  var now = Date.now().valueOf() / 1000;
  return typeof decoded.payload.exp === 'undefined' ? false : now > decoded.payload.exp;
}

function setReferrerUri(uri) {
  window.sessionStorage.setItem(REFERRER_URI_KEY, uri || (window.location.pathname === undefined ? '' : window.location.pathname) + (window.location.search === undefined ? '' : window.location.search) + (window.location.hash === undefined ? '' : window.location.hash));
}

function getReferrerUri() {
  var uri = window.sessionStorage.getItem(REFERRER_URI_KEY);
  window.sessionStorage.removeItem(REFERRER_URI_KEY);
  return uri || '/';
}

var AtmosConfigurationError = /*#__PURE__*/function (_Error) {
  _inherits(AtmosConfigurationError, _Error);

  var _super = _createSuper(AtmosConfigurationError);

  function AtmosConfigurationError() {
    _classCallCheck(this, AtmosConfigurationError);

    return _super.apply(this, arguments);
  }

  return AtmosConfigurationError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
var DEFAULT_SCOPES = ['openid', 'profile', 'email']; // Refresh Token

var DEFAULT_SCOPES_REFRESH = ['openid', 'profile', 'email', 'offline_access'];
var BLK_BASE_URI = 'https://blackrock.com/authplatform';
var TEST3_BASE_URI = 'https://test3.blackrock.com/authplatform';
var TESTC_BASE_URI = 'https://testc.blackrock.com/authplatform';
var AZRC_BASE_URI = 'https://azrc.blackrock.com/authplatform';
var PREVIEW_BASE_URI = 'https://preview.blackrock.com/authplatform';
var SIGN_IN = '/user/signin';
var CHANGE_CREDENTIALS = '/user/change-credentials';
var CHANGE_USER_NAME = '/user/change-username';
var CHANGE_RECOVERY_QUESTION = '/user/change-recovery-question';

var AtmosAuth = function AtmosAuth(config) {
  var _this = this;

  _classCallCheck(this, AtmosAuth);

  if (!config.clientId) {
    throw new AtmosConfigurationError('The Okta Client ID is missing. Please pass it into the configuration object on initialization.');
  }

  if (!config.issuer) {
    throw new AtmosConfigurationError('The Okta Issuer is missing. Please pass it into the configuration object on initialization.');
  }

  if (!config.redirectUri) {
    throw new AtmosConfigurationError('The Redirect URI is missing. Please pass it into the configuration object on initialization.');
  }

  if (!config.logoutUri) {
    throw new AtmosConfigurationError('The Logout URI is missing. Please pass it into the configuration object on initialization.');
  }

  if (!config.env) {
    throw new AtmosConfigurationError('env is missing. Please designate either DEV, TSZ, PROD, or provide another URL.');
  }

  this.clientId = config.clientId;
  this.issuer = config.issuer;
  this.refresh = config.refresh ? true : false;
  this.disableForgotPwd = config.disableForgotPwd ? true : false;
  this.aladdinAuth = config.aladdinAuth ? true : false;
  this.disableRegistration = config.disableRegistration ? true : false;
  this.invTypeHint = config.invTypeHint ? config.invTypeHint == 'fin' ? 'fin' : config.invTypeHint == 'ins' ? 'ins' : 'ind' : 'ind';
  this.postCredentialOperationRedirectUri = config.postCredentialOperationRedirectUri;
  this.locale = config.locale;
  this.scopes = config.scopes ? config.scopes : this.refresh ? DEFAULT_SCOPES_REFRESH : DEFAULT_SCOPES;
  this.redirectUri = config.redirectUri;
  this.logoutUri = config.logoutUri;
  this.site = config.site;
  this.brand = config.brand;
  this.idpName = config.idpName;
  this.BASE_URI = resolveBaseUri(config.env);
  this.LOGOUT_ENDPOINT = this.issuer + '/v1/logout';
  this.REVOKE_ENDPOINT = this.issuer + '/v1/revoke';
  this.TOKEN_ENDPOINT = this.issuer + '/v1/token';
  this.AUTHORIZE_ENDPOINT = this.issuer + '/v1/authorize';
  this.KEYS_ENDPOINT = this.issuer + '/v1/keys?client_id=' + this.clientId;
  this.CUSTOM_LOGIN_URI = this.BASE_URI + SIGN_IN;
  this.CHANGE_CREDENTIALS_URI = this.BASE_URI + CHANGE_CREDENTIALS;
  this.CHANGE_USER_NAME_URI = this.BASE_URI + CHANGE_USER_NAME;
  this.CHANGE_RECOVERY_QUESTION_URI = this.BASE_URI + CHANGE_RECOVERY_QUESTION;
  var pathArray = this.issuer.split('/');
  var protocol = pathArray[0];
  var host = pathArray[2];
  this.SESSIONS_ENDPOINT = protocol + '//' + host + '/api/v1/sessions/me';

  this.logout = function () {
    var uri = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return logout(_this, uri);
  };

  this.login = function () {
    var uri = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var customState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var externalIdp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    return login(_this, uri, customState, externalIdp);
  };

  this.isAuthenticated = function () {
    return isAuthenticated();
  };

  this.retrieveAndStoreTokens = function () {
    return retrieveAndStoreTokens(_this);
  };

  this.retrieveAndStoreNewTokens = function () {
    return retrieveAndStoreNewTokens(_this);
  };

  this.getAccessToken = function () {
    return getAccessToken();
  };

  this.getIdToken = function () {
    return getIdToken();
  };

  this.getRefreshToken = function () {
    return getRefreshToken();
  };

  this.getUserName = function () {
    return getUserName();
  };

  this.getUserId = function () {
    return getUserId();
  };

  this.isExpired = function (token) {
    return isExpired(token);
  };

  this.getExpiry = function () {
    return getExpiry();
  };

  this.redirectToCustomLogin = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return redirectToCustomLogin(_this, state);
  };

  this.redirectToChangeCredentials = function () {
    return redirectToChangeCredentials(_this);
  };

  this.redirectToChangeRecoveryQuestion = function () {
    return redirectToChangeRecoveryQuestion(_this);
  };

  this.redirectToChangeUsername = function () {
    return redirectToChangeUsername(_this);
  };

  this.getSession = function () {
    return getSession(_this);
  };

  this.decodeToken = function (token) {
    return decodeToken$1(token);
  }; // For testing purposes


  this.requestAuthCode = function () {
    return requestAuthCode(_this);
  };

  this.verifyState = function () {
    return verifyState();
  };

  this.getReferrerUri = function () {
    return getReferrerUri();
  };
};

function resolveBaseUri(env) {
  if (env == 'BLK') return BLK_BASE_URI;
  if (env == 'TEST3') return TEST3_BASE_URI;
  if (env == 'TESTC') return TESTC_BASE_URI;
  if (env == 'AZRC') return AZRC_BASE_URI;
  if (env === 'PREVIEW') return PREVIEW_BASE_URI;
  return env;
}

export { AtmosAuth, decodeToken$1 as decodeToken, getAccessToken, getExpiry, getIdToken, getNonce, getReferrerUri, getRefreshToken, getSession, getUserId, getUserName, isAuthenticated, isExpired, login, logout, redirectToChangeCredentials, redirectToChangeRecoveryQuestion, redirectToChangeUsername, redirectToCustomLogin, requestAuthCode, retrieveAndStoreNewTokens, retrieveAndStoreTokens, verifyState };
